import React, { useCallback } from 'react'
import API from '../../../../services/api'
import { useMemoRequest } from '../../../../hooks/useMemoRequest'
import SimpleModal from '../../../organisms/standard-modal/SimpleModal'
import AuditLogsTable from './AuditLogsTable'
import LoadingSpinner from '../../../atoms/loadingspinner/LoadingSpinner'
import Banner from '../../../atoms/banner/Banner'
import VerticalGroup from '../../../atoms/verticalgroup/VerticalGroup'

interface Props {
  isOpen: boolean
  onClose: () => void
  event: API.EventResponseSummary
}

function AuditLogsModal({ isOpen, onClose, event }: Props) {

  const getAudits = useCallback(() => {
    return API.getEventAuditLog(event.id)
  }, [event.id])

  const { inProgress, data, error } = useMemoRequest<API.AuditResponse[]>(getAudits)

  return (
    <SimpleModal
      size='large'
      isOpen={isOpen}
      onClose={onClose}
      isScrollable
    >
      <VerticalGroup spaceBetweenElements={2}>
        <h2>Audit Logs</h2>
        {error && <Banner type='error' active={!!error} message={error?.message} />}
        {inProgress && <LoadingSpinner />}
        {data && <VerticalGroup wide center>
          <AuditLogsTable auditlogs={data} />
        </VerticalGroup>}
      </VerticalGroup>
    </SimpleModal>

  )
}

export default AuditLogsModal